<h2>{{localize(langSection.NoLocationPage, langText.Header)}}</h2>
<notification
  [title]="localize(langSection.NoLocationPage, langText.NoticeTitle)"
  [message]="localize(langSection.NoLocationPage, langText.NoticeText)"
  [allowClose]="false"
></notification>
